import script from "./GoogleIframeMap.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleIframeMap.vue?vue&type=script&setup=true&lang=js"

import "./GoogleIframeMap.vue?vue&type=style&index=0&id=6f8c2370&lang=css"

const __exports__ = script;

export default __exports__